import RestService from "@/services/RestService";

function getLessons() {
  const data = {};
  return RestService.sendReq("get", "get_courses", data);
}

function getStudentsResults(studentGroupe) {
  const data = {};
  return RestService.sendReq(
    "get",
    `get_student_group_results/${studentGroupe}`,
    data
  );
}

function getStudentsLists(classId) {
  const data = {};
  return RestService.sendReq(
    "get",
    `get_teacher_course_result/${classId}`,
    data
  );
}

function getJournal(id, grade, start, end, selectFilter) {
  const data = {
    course_id: id,
    student_group_id: grade,
    start,
    end,
    selectFilter,
  };
  return RestService.sendReq("get", `class_journal`, data);
}

function loadStudentEvaluation(classId, studentLessonId) {
  const data = {};
  return RestService.sendReq(
    "get",
    `get_teacher_lesson_result/${classId}/${studentLessonId}`,
    data
  );
}

function putToJournal(lessonId, totalEvaluation) {
  const data = {
    evaluation: totalEvaluation,
  };
  return RestService.sendReq(
    "put",
    `teacher_review_student_lesson/${lessonId}`,
    data
  );
}

function backToRedo(evaluationId, teacherComment) {
  const data = {
    teacher_comment: teacherComment,
    need_reevaluation: true,
    evaluation: 0,
  };
  return RestService.sendReq("put", `review_evaluation/${evaluationId}`, data);
}

function addColumn(data) {
  return RestService.sendReq("post", "class_journal_edit", data);
}

function updateColumn(id, data) {
  return RestService.sendReq("put", `class_journal_edit/${id}`, data);
}

function removeColumn(lessonId) {
  const data = {};

  return RestService.sendReq("delete", `class_journal_edit/${lessonId}`, data);
}

function calculateTheme(lessonId) {
  const data = {};
  return RestService.sendReq(
    "post",
    `recalculate_theme_evaluation/${lessonId}`,
    data
  );
}

export default {
  getLessons,
  getStudentsLists,
  getJournal,
  addColumn,
  updateColumn,
  removeColumn,
  calculateTheme,
  getStudentsResults,
  loadStudentEvaluation,
  putToJournal,
  backToRedo,
};
